import {Component, Input} from '@angular/core';
import {UntypedFormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-is-company',
  templateUrl: './is-company.component.html',
  styleUrls: ['../../sign-up.component.scss'],
})
export class IsCompanyComponent {

  @Input() isCompanyControl:UntypedFormControl = new UntypedFormControl(null,Validators.required);

}
